/**
 * Determines the default route for a user based on their allowed features
 * @param allowedFeatures - Array of feature strings the user has access to
 * @returns The default route path for the user
 */
export function getDefaultRoute(allowedFeatures: string[]): string {
  // Priority order: full_platform > visitor_management > settings (fallback)
  if (allowedFeatures.includes("full_platform")) {
    return "/dashboard";
  }
  if (allowedFeatures.includes("visitor_management")) {
    return "/visitors";
  }
  return "/settings";
}

/**
 * Checks if a user has access to a specific feature
 * @param requiredFeature - The feature required to access a route (undefined means public route)
 * @param allowedFeatures - Array of features the user has access to
 * @returns true if user has access, false otherwise
 */
export function hasFeatureAccess(
  requiredFeature: string | undefined,
  allowedFeatures: string[],
): boolean {
  // No feature requirement means route is accessible to all authenticated users
  if (!requiredFeature) {
    return true;
  }
  // Check if user's allowed features include the required feature
  return allowedFeatures.includes(requiredFeature);
}
